import { BaseEntityDto } from '@fleet-beat/core';
import { DriverDto } from '@fleet-beat/api';

export interface ActivityReportsDto extends BaseEntityDto {
  driver?: DriverDto;
  distance?: number;
  date?: string;
}
